import React from 'react';
import ShowMore from 'emerald-ui/lib/ShowMore';
import populateDocs from './utils/populateDocs';

export default {
  ...populateDocs([{ component: ShowMore, componentName: 'ShowMore' }], 'ShowMore'),
  description: (
    <span>
      Used to partially hide parts of a section. Generally used with lists of items. Accepts a single{' '}
      <span className="code">ul</span> or a series of nodes.
    </span>
  ),
  codeSamples: [
    {
      title: 'Default',
      scope: { ShowMore },
      code: `<ShowMore show={2}>
  <p>Item 1</p>
  <p>Item 2</p>
  <p>Item 3</p>
  <p>Item 4</p>
  <p>Item 5</p>
</ShowMore>`,
    },
  ],
};
